import { go as fuzzySort } from 'fuzzysort';
function fuzzySearch(items, options) {
    return (searchString) => {
        return fuzzySort(searchString, items, {
            all: true,
            threshold: -10000,
            keys: [],
            ...options,
        }).map((x) => x.obj);
    };
}
export default fuzzySearch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnV6enlTZWFyY2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvaG9va3MvdXNlRnV6enkvZnV6enlTZWFyY2gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEVBQUUsSUFBSSxTQUFTLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFJNUMsU0FBUyxXQUFXLENBQ2hCLEtBQWlCLEVBQ2pCLE9BQXFDO0lBRXJDLE9BQU8sQ0FBQyxZQUFvQixFQUFFLEVBQUU7UUFDNUIsT0FBTyxTQUFTLENBQUMsWUFBWSxFQUFFLEtBQUssRUFBRTtZQUNsQyxHQUFHLEVBQUUsSUFBSTtZQUNULFNBQVMsRUFBRSxDQUFDLEtBQUs7WUFDakIsSUFBSSxFQUFFLEVBQUU7WUFDUixHQUFHLE9BQU87U0FDYixDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDekIsQ0FBQyxDQUFDO0FBQ04sQ0FBQztBQUVELGVBQWUsV0FBVyxDQUFDIn0=